import {FilterModes, SearchModes} from "../actions";

const defaultProductionStatusSelection = ['new', 'active'];
export const defaultAttributeFilters = {product_state: defaultProductionStatusSelection};
const parameters = (state = {
  filters: {},
  page: 0,
  sort: [],
  attributeFilters: defaultAttributeFilters,
  not_recommended_fnd: false,
  rangeAttributeFilters: {},
  withSeries: false,
  mode: FilterModes.DEFAULT,
  activeMode: false,
  activeSearchMode: SearchModes.TABLE,
  alternateSearchPage: 0,
  removedAttributeFilters: {},
}, action) => {
  const filters = {...state.filters};
  let attributeFilters = defaultAttributeFilters;
  let rangeAttributeFilters = {};
  let removedAttributeFilters = {};
  let page = 0;
  const resetted_state = {
    filters: {},
    page: 0,
    sort: [],
    attributeFilters: defaultAttributeFilters,
    not_recommended_fnd: false,
    rangeAttributeFilters: {},
    removedAttributeFilters: {},
    withSeries: false,
  };

  const dependentFilterKeys = ['group', 'category', 'lineup', 'series'];

  switch (action.type) {
    case 'SET_FILTER_MODE':
      if (action.reset) {
        return { ...state, ...resetted_state, mode: action.mode };
      }
      else {
        return { ...state, mode: action.mode, activeSearchMode: SearchModes.TABLE };
      }

    case 'SET_ACTIVE_MODE':
      return { ...state, activeMode: action.mode };

    case 'SET_ACTIVE_SEARCH_MODE':
      return { ...state, activeSearchMode: action.mode };

    case 'SELECT_SORT':
      return { ...state, sort: action.sort_object };

    case 'SELECT_FILTER':
      // Reset attributes filter every time when there is a filter selected.
      // keep product_state
      attributeFilters = {product_state: state.attributeFilters.product_state};
      rangeAttributeFilters = {};
      let withSeries = state.withSeries;

      dependentFilterKeys.forEach(filterKey => {
          if (action.filter_value === null || action.filter_value === "null" || action.id === filterKey || filters[filterKey] === null || filters[filterKey] === 'null') {
            delete filters[filterKey];
          }
        }
      );

      if(action.id === 'group'){
        delete filters['category'];
        delete filters['series'];

        delete filters['lineup'];
      } else if (action.id === 'category'){
        delete filters['series'];
        delete filters['lineup'];
        // TODO check this again
        /* delete filters['group']; */
      }

      filters[action.id] = action.filter_value;
      if (Object.prototype.hasOwnProperty.call(filters, 'lineup')) {
        withSeries = true;
      }
      return { ...state, filters, withSeries, attributeFilters, page };

    case 'SELECT_FILTER_PERSISTENT':
      // Alternate version of "SELECT_FILTER which keeps attribute filters
      // used in "initialize" function to retain URL attributes
      attributeFilters = state.attributeFilters;
      rangeAttributeFilters = state.rangeAttributeFilters;
      let withSeries_ = state.withSeries;

      dependentFilterKeys.forEach(filterKey => {
        if (action.id === filterKey || filters[filterKey] === null || filters[filterKey] === 'null') {
          delete filters[filterKey];
        }
      });

      filters[action.id] = action.filter_value;
      if (Object.prototype.hasOwnProperty.call(filters, 'lineup')) {
        withSeries_ = true;
      }
      return { ...state, filters, withSeries_, attributeFilters, page };

    case 'SELECT_ATTRIBUTE_FILTER':
      attributeFilters = state.attributeFilters;
      attributeFilters[action.id] = action.filter_value;
      return { ...state, attributeFilters, page };

    case 'RANGE_ATTRIBUTE_FILTER':
      rangeAttributeFilters = state.rangeAttributeFilters;
      rangeAttributeFilters[action.id] = action.filter_value;
      return { ...state, rangeAttributeFilters, page };

    case 'SELECT_ATTRIBUTE_FILTERS':
      let attributeFilters_ = state.attributeFilters;
      attributeFilters = Object.assign(attributeFilters_, action.attributeFilters);
      return { ...state, attributeFilters };

    case 'SELECT_RANGE_ATTRIBUTE_FILTERS':
      let rangeAttributeFilters_ = state.rangeAttributeFilters;
      rangeAttributeFilters = Object.assign(rangeAttributeFilters_, action.rangeAttributeFilters);
      return { ...state, rangeAttributeFilters };

    case 'SET_REMOVED_ATTRIBUTE_COLUMN':
      removedAttributeFilters = Object.assign({}, action.removedAttributeFilters);
      return { ...state, removedAttributeFilters };

    case 'ADD_REMOVED_ATTRIBUTE_COLUMN':
      removedAttributeFilters = state.removedAttributeFilters;
      removedAttributeFilters[action.id] = action.id;
      return { ...state, removedAttributeFilters };

    case 'REMOVE_REMOVED_ATTRIBUTE_COLUMN':
      removedAttributeFilters = state.removedAttributeFilters;
      if (Object.prototype.hasOwnProperty.call(removedAttributeFilters, action.id)) {
        delete removedAttributeFilters[action.id];
        return { ...state, removedAttributeFilters };
      }
      return state;

    case 'RESET_ON_FILTER':
      filters['search'] = '';
      // keep product_state => why?
      attributeFilters = {product_state: state.attributeFilters.product_state};
      const reset_on_filter_state = {
        page: 0,
        sort: [],
        attributeFilters: attributeFilters,
        rangeAttributeFilters: {},
        removedAttributeFilters: {},
      };
      return { ...state, ...reset_on_filter_state, filters };

    case 'RESET_ON_SEARCH':
      const to_delete = ['group', 'category', 'model', 'series', 'lineup'];
      for (let delete_var of to_delete) {
        if (Object.prototype.hasOwnProperty.call(filters, delete_var)) {
          delete filters[delete_var];
        }
      }

      // this resets the default attributes eg. product_state ...
      const reset_on_search_state = {
        page: 0,
        sort: [],
        attributeFilters: {},
        rangeAttributeFilters: {},
        removedAttributeFilters: {},
      };
      return { ...state, ...reset_on_search_state, filters };

    case 'INNER_RESET_ALL':
      filters['attribute_search'] = '';
      const inner_resetted_state = {
        page: 0,
        sort: [],
        rangeAttributeFilters: {},
        removedAttributeFilters: {},
      };
      return { ...state, ...inner_resetted_state, attributeFilters: {product_state: defaultProductionStatusSelection}, not_recommended_fnd: false, filters };

    case 'UPDATE_PAGE':
      return { ...state, page: action.page };

    case 'UPDATE_ALTERNATE_PAGE':
      return { ...state, alternateSearchPage: action.page };

    default:
      return state;
  }
}

export default parameters
